export const GENERAL_SET_GRAPH_DATA = "GENERAL_SET_GRAPH_DATA";
export const GENERAL_SET_PIE_DATA = "GENERAL_SET_PIE_DATA";
export const GENERAL_TRASACTION = "GENERAL_TRASACTION";
export const EXPAND_ACCORD = "EXPAND_ACCORD";
export const NESTED_ACCORD = "NESTED_ACCORD";
export const PIE_DATA_EMPTY = "PIE_DATA_EMPTY";
export const HIGHLIGHT_PIE = "HIGHLIGHT_PIE";
export const RESET_PORTFOLIO = "RESET_PORTFOLIO";
export const RESET_GENERAL_PORT = "RESET_GENERAL_PORT";
export const RESET_DATA = "RESET_DATA";
